
import "@/styles/pages/screenshotVideo/index.css";
import compatibleVue from "@/service/compatibleVue";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            
const workbenchDom = $(".workbench")[0];
const workbenchContainer = workbenchDom.parentNode;
$(workbenchDom).remove();

const cVue = compatibleVue();
cVue.process();

new Vue({
  created($, apower) {
    $.callOnInteractive(async function () {
      cVue.recover();
      const appPromises = [
        1 && import("./app.js"),
        $.loadScript(`${window.CDNDOMAIN}/lib/vue.min.js`),
        $.loadScript(`${window.CDNDOMAIN}/lib/axios.min.js`),
        $.loadScript(`${window.CDNDOMAIN}/lib/aliyun-oss-sdk.js`),
        $.loadScript(`${window.CDNDOMAIN}/js/canvas2image.js`),
        $.loadScript(`${window.CDNDOMAIN}/lib/FileSaver.min.js`),
        $.loadScript(`${window.CDNDOMAIN}/js/jszip.min.js`),
      ];
      const [moutApp] = await Promise.all(appPromises);
      workbenchContainer.appendChild(workbenchDom);
      moutApp.default();
      $("#app .rating").empty();
      $.newComponent({ el: $("#app .main-write") });
    });

    Promise.resolve().then(replaceDownloadHref);

    function replaceDownloadHref() {
      const observer = new MutationObserver(() => {
        const downloadBtns = document.querySelectorAll(
          "a[href^='https://download.apowersoft.']"
        );
        downloadBtns.forEach((item) => {
          item.href =
            "https://download.aoscdn.com/down.php?softid=lighteditor-saas-RL-online-editor";
        });
      });
      observer.observe(document.querySelector("body"), {
        subtree: true,
        childList: true,
      });
    }
  },
});

          })
        